import React from "react"
import { union } from "lodash"

import { jsPDF } from "jspdf"
import { autoTable } from "jspdf-autotable"

import { config } from "Utils/config"
import xlsx from "xlsx"

export const version = "v1.0.0"

const LANGUAGE_ID_BY_ISO = {
  en: 0,
  fr: 1,
  de: 2,
  it: 3,
  es: 4,
  pt: 5,
}

const getNormalizedLang = lang => {
  if (!lang || typeof lang !== "string") return ""
  return lang.toLowerCase().split(/-|_/)[0]
}

const resolveLanguageId = lang => LANGUAGE_ID_BY_ISO[getNormalizedLang(lang)] ?? 0

const isValidVersion = name => {
  const regex = new RegExp(/^v[0-9]*\.[0-9]*\.[0-9]*$/)
  return name !== undefined && regex.test(name)
}

export const getVersion = () => {
  const { CI_COMMIT_TAG } = config

  if (isValidVersion(CI_COMMIT_TAG)) return CI_COMMIT_TAG

  return version
}

export const getLangageIdFromNavigator = () => {
  try {
    return resolveLanguageId(getBrowserLang() || navigator?.language || navigator?.userLanguage)
  } catch (error) {
    return 0
  }
}

// Vieux obsolete, mais obligatoire pour le moment :/
export const fetchImageAsBlobUrlSync = (url, token) => {
  const xhr = new XMLHttpRequest()
  xhr.open("GET", url, false) // ⛔ synchrone
  xhr.setRequestHeader("Authorization", `Bearer ${token}`)
  xhr.responseType = "arraybuffer" // ✅ autorisé

  try {
    xhr.send()
    if (xhr.status >= 200 && xhr.status < 300) {
      const blob = new Blob([xhr.response])
      return URL.createObjectURL(blob)
    } else {
      console.error(`Erreur HTTP ${xhr.status}`)
      return null
    }
  } catch (err) {
    console.error("Erreur XHR", err)
    return null
  }
}

export const navbarHeight = {
  laptop: "56px",
  mobile: "48px",
}
export const defaultColorPocket = "#01014B"

export const commonGrayPocket = "#707070"
export const widgetSettingsBgInputGray = "#F8F8F8"
export const widgetSettingsBorderInputGray = "#DCDCDC"

// ADMIN CONSOLE
export const adminConsoleColors = {
  redPocket: defaultColorPocket,
  green: "#0c9129",
  commonGrayPocket,
  lightGrey: "#DEDEDE",
  darkGrey: "#787878",
  grey: "#393B4B",
  white: "#FFFFFF",
  lightTurquoise: "#447E87",
  red: "#FC2D45",
}

export const getRandomColor = () => {
  var letters = "0123456789ABCDEF"
  var color = "#"
  for (var i = 0; i < 6; i++) {
    color += letters[Math.floor(Math.random() * 16)]
  }
  return color
}

export const getBrowserLang = () => {
  return navigator?.language || navigator?.userLanguage
}

export const getTradLangageIdFromNavigator = () => {
  try {
    return resolveLanguageId(getBrowserLang())
  } catch (error) {
    return 0
  }
}

export const lowerFirstLetter = string => {
  return string.charAt(0).toLowerCase() + string.slice(1)
}

export const getAllSelectedRowsFromTableData = tableData => {
  if (tableData?.selectedFlatRows?.length) {
    const selectedFlatRows = tableData.selectedFlatRows
    const unGroupedRows = selectedFlatRows.filter(selectedFlatRow => !selectedFlatRow.isGrouped)
    const groupedRows = selectedFlatRows.filter(selectedFlatRow => selectedFlatRow.isGrouped)
    const subRows = []
    groupedRows.forEach(groupedRow => {
      groupedRow.subRows.forEach(subRow => {
        subRows.push(subRow)
      })
    })
    var fullRowSelected = [...unGroupedRows, ...subRows]
    var rowMap = new Map(fullRowSelected.map(row => [row?.original?.uuid, row]))
    var uniqueRows = [...rowMap.values()]
    return uniqueRows
  }
  return []
}

export const getSelectedRowsFromDataCatalogue = selectedRows => {
  if (selectedRows && selectedRows.length) {
    const uniquesRows = new Map(selectedRows.map(row => [row?.data?.uuid, row]))
    return [...uniquesRows.values()]
  }
  return []
}

// ⚠️ Cinq helpers de statut d'accès à une page ont été SUPPRIMÉS ici avec la modale de partage
// v1 (`canViewPage`, `getPageAccessStatus`, `getPageAccessStatusName`,
// `getPageAccessStatusNameWithAccessStatus`, `getPermissionFormStatus`). Vérifié avant coupe :
// zéro consommateur hors ce fichier — la modale v1 était le seul appelant, et une partie de la
// grappe ne s'appelait qu'elle-même.
//
// L'un d'eux rendait des libellés FRANÇAIS EN DUR (« Propriétaire », « Editeur », « Lecteur »,
// « Non-authorisé ») : un manquement i18n qui a survécu des années parce que le code n'était
// atteignable que depuis cet écran. La v2 passe par `trad?.KEY || "English fallback"`.

//V1
export const isObject = objectToCheck => {
  return objectToCheck !== null && objectToCheck?.constructor?.name === "Object"
}

//V2
export const isObjectV2 = obj => {
  return obj?.constructor === Object
}

export const isDate = myVar => {
  return Object.prototype.toString.call(myVar) === "[object Date]"
}

//V3
export const isObjectV3 = myVar => {
  return typeof myVar === "object" && !Array.isArray(myVar) && !isDate(myVar) && myVar !== null
}

export const exportDatas = (objectToExport = {}, fileType, fileName) => {
  const name = fileName !== "" ? fileName : "export"

  const { header = [], body = [[]] } = objectToExport
  if (fileType === "csv") {
    // CSV example
    let csvString = "\ufeff"
    const headerNames = header.join(";") + "\n"
    csvString += headerNames
    body.forEach(row => {
      const string = row.join(";") + "\n"
      csvString += string
    })
    getCSVfromString(csvString, name)
    return false
  } else if (fileType === "xlsx") {
    // XLSX example
    const xlsxDatas = body.map(row => {
      const xlsxObject = {}
      header.forEach((col, index) => {
        let value = row[index]
        xlsxObject[col] = value
      })
      return xlsxObject
    })

    let workbook = xlsx.utils.book_new()
    let worksheet1 = xlsx.utils.json_to_sheet(xlsxDatas, {
      header,
    })
    xlsx.utils.book_append_sheet(workbook, worksheet1, "export")
    xlsx.writeFile(workbook, `${name}.xlsx`)

    // Returning false as downloading of file is already taken care of
    return false
  }
  //PDF example
  if (fileType === "pdf") {
    const doc = new jsPDF({ orientation: "landscape" })
    autoTable(doc, {
      head: [header],
      body: body,
      margin: { top: 20 },
      styles: {
        minCellHeight: 9,
        halign: "left",
        valign: "center",
        fontSize: 11,
      },
    })
    const numberOfPages = doc.internal.getNumberOfPages()
    for (let i = 1; i <= numberOfPages; i++) {
      doc.setPage(i)
      doc.text(140, 205, `Page ${i} of ${numberOfPages}`)
    }
    doc.save(`${fileName}.pdf`)

    return false
  }

  // Other formats goes here
  return false
}

export const getCSVfromString = (csvString, fileName) => {
  const blob = new Blob([csvString], { type: "text/csv" })
  var link = document.createElement("a")
  if (link.download !== undefined) {
    // feature detection
    // Browsers that support HTML5 download attribute
    var url = URL.createObjectURL(blob)
    link.setAttribute("href", encodeURI(url))
    link.setAttribute("download", fileName + ".csv")
    link.style.visibility = "hidden"
    document.body.appendChild(link)
    link.click()
    document.body.removeChild(link)
  }
}

export const getContrastedColor = (
  hexcolor = "#ffffff",
  colorBlackToReturn = "black",
  colorWhiteToReturn = "white"
) => {
  if (hexcolor) {
    let hex = hexcolor?.replace("#", "")
    var r = parseInt(hex?.substr(0, 2), 16)
    var g = parseInt(hex?.substr(2, 2), 16)
    var b = parseInt(hex?.substr(4, 2), 16)
    var yiq = (r * 299 + g * 587 + b * 114) / 1000
    return yiq >= 128 ? colorBlackToReturn : colorWhiteToReturn
  }
}

export const getContrastedColorWithGradient = (
  useGradient,
  colorGradient,
  colorMain,
  colorBlackToReturn,
  colorWhiteToReturn
) => {
  if (useGradient && colorGradient) {
    return getContrastedColor(colorGradient, colorBlackToReturn, colorWhiteToReturn)
  } else if (colorMain && !useGradient) {
    return getContrastedColor(colorMain, colorBlackToReturn, colorWhiteToReturn)
  } else {
    return "grey"
  }
}

export const getFirstLetterUppercase = word => {
  if (!word) return ""
  const transformedWord = word.charAt(0)?.toUpperCase() + word.slice(1)
  return transformedWord
}

export const isHexaColor = hexa => {
  return /^#([A-Fa-f0-9]{3}){1,2}$/.test(hexa)
}

//exemple #03f
export const simplifiedHexaColorRegex = /^#?([a-f\d])([a-f\d])([a-f\d])$/i

export const isSimplifiedHexaColor = hexa => {
  return simplifiedHexaColorRegex.test(hexa)
}

export const getRRGGBBfromRGB = simpleHexa => {
  return simpleHexa.replace(/^#?([a-f\d])([a-f\d])([a-f\d])$/i, (m, r, g, b) => {
    return "#" + r + r + g + g + b + b
  })
}
//v1
// export const hexaToRgbArray = (hexa) => {
//   if(!hexa || !isHexaColor(hexa)) return []

//   var c = hexa.substring(1).split('')
//   if(c.length === 3){
//     c = [c[0], c[0], c[1], c[1], c[2], c[2]]
//   }
//   c = '0x' + c.join('')
//   return [(c>>16)&255, (c>>8)&255, c&255]
// }

//v2
export const hexaToRgbArray = hexa => {
  if (!hexa || !isHexaColor(hexa)) return []

  var fullHexa = hexa
  if (isSimplifiedHexaColor(hexa)) {
    fullHexa = getRRGGBBfromRGB(hexa)
  }
  var strWithoutFirstLetter = fullHexa.substring(1)
  var twoCharList = strWithoutFirstLetter.match(/.{2}/g)
  return twoCharList.map(x => parseInt(x, 16))
}

export const rgbArrayToString = (rgbArr, opacity = 1) => {
  return `rgba(${rgbArr.join(", ")}, ${opacity})`
}

export function hexToRgbA(hexa, opacity = 1) {
  if (!hexa || !isHexaColor(hexa)) return ""
  var rgbArray = hexaToRgbArray(hexa)
  return rgbArrayToString(rgbArray, opacity)
}

export const getComponentBodyHeight = (studioHeaderHeight, componentHeaderHeight) => {
  if (!studioHeaderHeight) return "100vh"
  if (!componentHeaderHeight) return `calc(100vh - ${studioHeaderHeight}px)`
  return `calc(100vh - ${studioHeaderHeight}px - ${componentHeaderHeight}px)`
}

export const getStringRemoveSpecialCharacters = string => {
  if (typeof string !== "string") return ""
  return string
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .replace(/[^\w\s.-]/gi, "")
}

export const areArrays = listArrays => {
  if (!Array.isArray(listArrays)) return false
  return listArrays.every(array => Array.isArray(array))
}

export const filterObjectProperties = (object, properties) => {
  if (!isObjectV2(object) || !Array.isArray(properties)) return {}
  const filteredObj = {}
  for (let property of properties) {
    if (object.hasOwnProperty(property)) {
      filteredObj[property] = object[property]
    }
  }
  return filteredObj
}

export const transformObjectToNestedKeyValuePairs = object => {
  if (!isObjectV2(object)) return []
  const objectKeys = Object.keys(object)
  return objectKeys.map(key => {
    return [key, object[key]]
  })
}

export const getBrowserName = () => {
  let nAgt = navigator.userAgent
  let browserName = navigator.appName

  if (nAgt.indexOf("OPR/") != -1) browserName = "Opera"
  else if (nAgt.indexOf("Opera") != -1) browserName = "Opera"
  else if (nAgt.indexOf("MSIE") != -1) browserName = "Microsoft Internet Explorer"
  else if (nAgt.indexOf("Chrome") != -1) browserName = "Chrome"
  else if (nAgt.indexOf("Safari") != -1) browserName = "Safari"
  else if (nAgt.indexOf("Firefox") != -1) browserName = "Firefox"

  return browserName
}

export const isFirefox = () => getBrowserName() === "Firefox"

export const getImageDimensions = file => {
  if (!file) return { width: 0, height: 0 }
  return new Promise(function (resolved, rejected) {
    const image = new Image()
    image.src = file
    image.onload = () => {
      resolved({ width: image.width, height: image.height })
    }
  })
}

export const getResizingImageProportionnal = (origWidth, origHeight, maxWidth, maxHeight) => {
  if (!origWidth || !origHeight || !maxWidth || !maxHeight) return { width: 0, height: 0 }
  let width = origWidth
  let height = origHeight

  if (width > maxWidth) {
    height = Math.round((height * maxWidth) / width)
    width = maxWidth
  }
  if (height > maxHeight) {
    width = Math.round((width * maxHeight) / height)
    height = maxHeight
  }

  return { width, height }
}

/**
 * Compresse et redimensionne une image pour réduire sa taille avant stockage dans localStorage
 * @param {string} dataUrl - Data URL de l'image à compresser
 * @param {number} maxWidth - Largeur maximale (défaut: 800)
 * @param {number} maxHeight - Hauteur maximale (défaut: 800)
 * @param {number} quality - Qualité de compression 0-1 (défaut: 0.7)
 * @returns {Promise<string>} - Data URL compressé
 */
export const compressImageForStorage = (dataUrl, maxWidth = 800, maxHeight = 800, quality = 0.7) => {
  return new Promise((resolve, reject) => {
    if (!dataUrl || typeof dataUrl !== "string") {
      reject(new Error("dataUrl invalide"))
      return
    }

    // Vérifier si c'est une image
    if (!dataUrl.startsWith("data:image/")) {
      // Si ce n'est pas une image, retourner tel quel
      resolve(dataUrl)
      return
    }

    const img = new Image()
    img.onload = () => {
      try {
        // Calculer les nouvelles dimensions
        const { width, height } = getResizingImageProportionnal(
          img.width,
          img.height,
          maxWidth,
          maxHeight
        )

        // Créer un canvas pour redimensionner et compresser
        const canvas = document.createElement("canvas")
        canvas.width = width
        canvas.height = height
        const ctx = canvas.getContext("2d")

        if (!ctx) {
          reject(new Error("Impossible de créer le contexte canvas"))
          return
        }

        // Dessiner l'image redimensionnée
        ctx.drawImage(img, 0, 0, width, height)

        // Convertir en dataUrl avec compression
        const mimeType = dataUrl.match(/data:([^;]+)/)?.[1] || "image/jpeg"
        const compressedDataUrl = canvas.toDataURL(mimeType, quality)

        resolve(compressedDataUrl)
      } catch (error) {
        console.error("Erreur lors de la compression de l'image:", error)
        // En cas d'erreur, retourner l'image originale
        resolve(dataUrl)
      }
    }

    img.onerror = () => {
      console.error("Erreur lors du chargement de l'image pour compression")
      // En cas d'erreur, retourner l'image originale
      resolve(dataUrl)
    }

    img.src = dataUrl
  })
}

/**
 * Stocke une valeur dans localStorage avec gestion des erreurs de quota
 * Si le quota est dépassé, tente de compresser l'image avant de stocker
 * @param {string} key - Clé localStorage
 * @param {string} value - Valeur à stocker (peut être un dataUrl d'image)
 * @param {boolean} isImage - Indique si la valeur est une image (défaut: true)
 * @returns {Promise<boolean>} - true si stockage réussi, false sinon
 */
export const safeSetLocalStorageItem = async (key, value, isImage = true) => {
  try {
    localStorage.setItem(key, value)
    return true
  } catch (error) {
    if (error.name === "QuotaExceededError" && isImage && value?.startsWith("data:image/")) {
      try {
        console.warn(`Quota localStorage dépassé pour ${key}, tentative de compression...`)
        const compressedValue = await compressImageForStorage(value, 600, 600, 0.6)
        localStorage.setItem(key, compressedValue)
        console.log(`Image compressée stockée avec succès pour ${key}`)
        return true
      } catch (compressError) {
        console.error(`Erreur lors de la compression pour ${key}:`, compressError)
        // Si la compression échoue aussi, on ne stocke pas
        return false
      }
    } else {
      console.error(`Erreur lors du stockage de ${key} dans localStorage:`, error)
      return false
    }
  }
}

export const calculateFunctionExecutionTime = func => {
  return function wrapper(...args) {
    const startTime = performance.now() // Récupère le temps de départ
    const result = func(...args) // Exécute la fonction décorée avec les arguments
    const endTime = performance.now() // Récupère le temps d'arrêt
    const executionTime = endTime - startTime // Calcule le temps d'exécution en soustrayant le temps de départ du temps d'arrêt
    console.log(`La fonction ${func.name} a été exécutée en ${executionTime} millisecondes.`)
    return result // Retourne le résultat de la fonction décorée
  }
}

export const hasMandatoryProperties = (object, mandatoryProperties) => {
  if (!isObjectV2(object) || !Array.isArray(mandatoryProperties)) return false
  return mandatoryProperties.every(key => {
    const value = object[key]
    return value !== null && value !== undefined && value !== ""
  })
}

export const getFullNamesForUserIds = (allUsers, usersIds) => {
  if (!Array.isArray(allUsers) || !Array.isArray(usersIds)) return []
  const concernedUsers = allUsers.filter(user => usersIds.includes(`${user?.USER_ID}`))
  return concernedUsers.map(user => `${user?.FIRSTNAME} ${user?.LASTNAME}`)
}

export const getNamesForGroupsIds = (allGroups, groupsIds) => {
  if (!Array.isArray(allGroups) || !Array.isArray(groupsIds)) return []
  const concernedGroups = allGroups.filter(groups => groupsIds.includes(`${groups?.id}`))
  return concernedGroups.map(group => group?.nom)
}

export const getNamesForUsersAndGroups = (allUsers, allGroups, arrayIds) => {
  if (!Array.isArray(allGroups) || !Array.isArray(arrayIds)) return []
  const getNameUser = getFullNamesForUserIds(allUsers, arrayIds)
  const getNameGroup = getNamesForGroupsIds(allGroups, arrayIds)
  return union(getNameGroup, getNameUser)
}

export const getFileExtension = fileName => {
  if (!fileName || typeof fileName !== "string") {
    console.warn("Avertissement : getFileExtension attend une chaîne valide en paramètre.")
    return undefined
  }
  if (fileName.indexOf(".") === -1) {
    console.warn("Avertissement : Le nom de fichier ne contient pas de point (.)")
    return undefined
  }
  const extension = fileName.split(".").pop()
  return `.${extension}`
}

export const getNormalizedText = text => {
  if (!text || typeof text !== "string") return ""
  return text
    .toLowerCase()
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
}

export const searchElementsByString = (elementsToSearch, keyToCompare, searchInputValue) => {
  if (!Array.isArray(elementsToSearch)) return []
  if (!keyToCompare || !searchInputValue) return elementsToSearch
  const searchValueNormalized = getNormalizedText(searchInputValue?.toUpperCase())
  return elementsToSearch.filter(element => {
    const labelNormalized = getNormalizedText(element?.[keyToCompare]?.toUpperCase())
    const labelIncludeValue = labelNormalized?.includes(searchValueNormalized)
    return labelIncludeValue
  })
}

export const hasCommonValues = (array1, array2) => {
  if (!Array.isArray(array1) || !Array.isArray(array2)) return false
  let setArray1 = new Set(array1)
  for (let value of array2) {
    if (setArray1.has(value)) return true
  }
  return false
}

// extraire le texte brut d'une chaîne de caractères HTML
export const stripHtml = html => {
  var temp = document.createElement("div")
  temp.innerHTML = html
  return temp.textContent || temp.innerText || ""
}

export const isEmptyObject = object => {
  if (!isObjectV2(object)) return false
  const isEmpty = Object.keys(object).length === 0 ? true : false
  return isEmpty
}

export const removeNullableValuesFromObject = obj => {
  if (typeof obj !== "object" || obj === null) {
    throw new Error("Expected an object as input")
  }

  return Object.fromEntries(
    Object.entries(obj).filter(([_, value]) => value != null && value !== undefined)
  )
}

export const toNumber = (v, fallback = 0) => {
  if (v == null) return fallback
  const n = typeof v === "number" ? v : parseFloat(String(v).replace(",", "."))
  return Number.isFinite(n) ? n : fallback
}
